import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EProductSearchSearchOrder } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-search-order.enum';
import { EProductSearchSearchOrderBy } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-search-order-by.enum';
import { EProductTemplatesSearchSortingParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-sorting-params';
import { EProductTemplatesListSortingOrderSelectorItem } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-list-sorting-order-selector-item';
import { map } from 'rxjs/operators';

@Component({
  selector: 'gd-product-templates-list-sorting-order-selector',
  templateUrl: './product-templates-list-sorting-order-selector.component.html',
  styleUrls: ['./product-templates-list-sorting-order-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListSortingOrderSelectorComponent {
  @Input() set sortingParams(sortingParams: EProductTemplatesSearchSortingParams) {
    this.sortingParams$.next(sortingParams);
  }

  @Output() sortingParamsChange = new EventEmitter<EProductTemplatesSearchSortingParams>();

  items: EProductTemplatesListSortingOrderSelectorItem[] = [
    [
      EProductSearchSearchOrderBy.UPDATED_AT,
      EProductSearchSearchOrder.DESC,
      'txt_product_templates_list_search_order_by_updated_at_desc',
    ],
    [
      EProductSearchSearchOrderBy.UPDATED_AT,
      EProductSearchSearchOrder.ASC,
      'txt_product_templates_list_search_order_by_updated_at_asc',
    ],
    [
      EProductSearchSearchOrderBy.CREATED_AT,
      EProductSearchSearchOrder.DESC,
      'txt_product_templates_list_search_order_by_created_at_desc',
    ],
    [
      EProductSearchSearchOrderBy.CREATED_AT,
      EProductSearchSearchOrder.ASC,
      'txt_product_templates_list_search_order_by_created_at_asc',
    ],
    [
      EProductSearchSearchOrderBy.TEMPLATE_NAME,
      EProductSearchSearchOrder.ASC,
      'txt_product_templates_list_search_order_by_template_name_asc',
    ],
    [
      EProductSearchSearchOrderBy.TEMPLATE_NAME,
      EProductSearchSearchOrder.DESC,
      'txt_product_templates_list_search_order_by_template_name_desc',
    ],
  ].map(
    ([orderBy, order, translationKey]): EProductTemplatesListSortingOrderSelectorItem => ({
      id: `${orderBy}-${order}`,
      orderBy: orderBy as EProductSearchSearchOrderBy,
      order: order as EProductSearchSearchOrder,
      translationKey: translationKey as string,
    }),
  );

  sortingParams$ = new BehaviorSubject<EProductTemplatesSearchSortingParams>(null);
  selectedItemId$ = this.sortingParams$.pipe(
    map((sortingParams: EProductTemplatesSearchSortingParams): string => {
      const selectedItem = this.items.find(
        (loopItem: EProductTemplatesListSortingOrderSelectorItem): boolean =>
          loopItem.order === sortingParams?.order && loopItem.orderBy === sortingParams?.orderBy,
      );

      return selectedItem?.id;
    }),
  );

  onSelect(id: string) {
    const item = this.items.find((loopItem: EProductTemplatesListSortingOrderSelectorItem) => loopItem.id === id);

    this.sortingParamsChange.emit({ order: item.order, orderBy: item.orderBy });
  }
}
